export enum DashboardRoles {
  VIEWER = 'roles.dashboardViewer',
}
